import store from "@/store";
import request from "@/utils/request";


export async function getCsFileList(params) {
    console.log("@@ get list : getCsFileList");
    let result = request.get("/api/cs/csFile/",{params});
    return result;
}

export async function getCsFileListByMapp(params) {
    console.log("@@ get list : getCsFileList By CsFileMapping");
    let result = request.get("/api/cs/csFile/mapp",{params});
    return result;
}

export async function getCsFileListNotMapp(params) {
    console.log("@@ get list : getCsFileList Not mapping");
    let result = request.get("/api/cs/csFile/notMapp",{params});
    return result;
}

export async function getCsFileItem(params) {
    console.log("@@ get item : getCsFileItem");
    let result = request.get(`/api/cs/csFile/${params.fileSeq}`,{params} );
    return result;
}

export async function getCsFileListByOrgContSeq(params) {
    console.log("@@ get list : getCsFileList By CsCont.orgContSeq (params.contSeq)");
    let result = request.get("/api/cs/csFile/orgContSeq",{params});
    return result;
}


export async function saveCsFile(params) {
    console.log("@@ post save : saveCsFile");
    let result = request.post(`/api/cs/csFile/`,params);
    return result;
}

export async function saveCsFileList(params) {
    console.log("@@ post save : saveCsFileList");
    let result = request.post(`/api/cs/csFile/list`,params);
    return result;
}

export async function deleteCsFile(params) {
    console.log("@@ delete : deleteCsFile");
    let result = request.delete(`/api/cs/csFile/${params.fileSeq}`,{params});
    return result;
}

export async function deleteUpdateCsFile(params) {
    console.log("@@ post upudate : deleteUpdateCsFile");
    let result = request.post("/api/cs/csFile/deleteUpdateCsFile",params);
    return result;
}

export async function uploadS3(params) {
    console.log("@@ post save : uploadS3", params);
    let result = request.post(`/api/cs/csFile/upload`,params);
    return result;
}

// aiclass용: S3 upload & t_up_file 등록
export async function uploadAiclass(params) {
    console.log("@@ post save : uploadAiclass", params);
    // let result = request.post(`/api/thirdparty/aiclass/upload/${params.uploadKey}`,params);
    let result = request.post(`/api/thirdparty/aiclass/upload`,params);
    return result;
}
export async function keygenAiclass(params) {
    console.log("@@ get save : uploadAiclass", params);
    // let result = request.post(`/api/thirdparty/aiclass/upload/${params.uploadKey}`,params);
    let result = request.get(`/api/thirdparty/aiclass/keygen`,{params});
    return result;
}

export async function uploadCsFile(params) {
    console.log("@@ post save : uploadCsFile");
    let result = request.post(`/api/cs/csFile/upload/file`,params);
    return result;
}

export async function uploadCsFileNotMapping(params) {
    console.log("@@ post save : uploadCsFileNotMapping");
    let result = request.post(`/api/cs/csFile/upload/notMapping`,params);
    return result;
}

export async function getCsFileListByMomentMapp(params) {
    console.log("@@ get list : getCsFileList By MomentFileMapping");
    let result = request.get("/api/cs/csFile/momentMapp",{params});
    return result;
}

export async function saveUpdateCsFile(params) {
    console.log("@@ post update: saveUpdateCsFile");
    let result = request.post("/api/cs/csFile/saveUpdateCsFile",params);
    return result;
}